import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import queryArgs from 'optinmonster-js-library/src/utils/queryArgs'
import { createNamespacedHelpers } from 'vuex'

const { mapMutations, mapActions, mapState } = createNamespacedHelpers('integrations')

export const oauth = {
	data () {
		return {
			oauthWindow   : null,
			oauthInterval : null,
		}
	},
	computed : {
		...mapState([ 'oauthActive' ]),
		oauthComplete () {
			return 'complete' === this.oauthActive
		},
		oauthInProgress () {
			return this.oauthActive && !this.oauthComplete
		},
	},
	methods : {
		...mapMutations([
			'setOauthActive',
			'setActiveContentError',
		]),
		...mapActions([ 'oauthPost' ]),
		/**
		 * Handle OAuth
		 *
		 * @since 2.4.0
		 *
		 * @param {string} endpoint The endpoint
		 *
		 * @returns {void}
		 */
		handleOauth (endpoint) {
			const path = endpoint || this.provider.supports.oauth

			this.openWindow(path)
		},
		/**
		 * Open Window
		 *
		 * @since 2.4.0
		 *
		 * @param {string} endpoint The endpoint
		 *
		 * @returns {void}
		 */
		openWindow (endpoint) {
			this.setOauthActive(true)

			let params = {}

			this.oauthWindow = window.open(
				endpoint,
				'ConnectWithOauth',
				'location=0,status=0,width=800,height=700'
			)

			window.addEventListener('message', this.listener)

			this.oauthInterval = window.setInterval(() => {
				try {
					params = queryArgs.parse(this.oauthWindow.location.search)
				} catch (e) {}

				if (params.code !== undefined || params.access_token !== undefined) {
					this.completeOauth(params)
				}

				if (this.oauthWindow && this.oauthWindow.closed) {
					this.stopListening()
					this.setOauthActive(false)
				}
			}, 1000)
		},
		/**
		 * Listener
		 *
		 * @since 2.4.0
		 *
		 * @param {event} event The event object.
		 *
		 * @returns {void}
		 */
		listener (event) {
			const eventData = get(event, 'data')
			const checkUrls = (url, messageUrl) => {
				return url.startsWith(messageUrl) || messageUrl === url
			}

			try {
				const appUrl     = this.$urls.app()
				const urlMatches = checkUrls(appUrl, event.origin)

				// If no data is passed, do nothing.
				if (isEmpty(eventData)) {
					throw new Error('Data is empty.')
				}

				const data = JSON.parse(eventData)
				if (!data || !get(data, 'builderOauth') || !data.params) {
					throw new Error('Invalid data.')
				}

				// If origins not matching.
				if (!urlMatches && !checkUrls(appUrl, data.origin)) {
					throw new Error(`Invalid origin. ${event.origin} vs ${data.origin} vs ${appUrl}`)
				}

				this.completeOauth(data.params)
			} catch (error) {
				error.data = eventData
				console.warn('postMessage error', { error })
			}
		},
		/**
		 * Params
		 *
		 * @since 2.4.0
		 *
		 * @param {Object} params The params object.
		 *
		 * @returns {void}
		 */
		completeOauth (params) {
			this.stopListening()

			const code = get(params, 'code') || get(params, 'access_token')

			if (code) {
				this.oauthPost({
					provider : this.slug,
					data     : { code },
				})
			} else {
				this.processOauthError(params)
			}

			try {
				this.oauthWindow.postMessage(
					JSON.stringify({
						builderOauth : true,
						close        : true,
					}),
					this.$urls.app()
				)
				this.oauthWindow.close()
				this.setOauthActive(false)
			} catch (e) {}
		},
		/**
		 * Process OAuth Error
		 *
		 * @since 2.4.0
		 *
		 * @param {Object} params The params object.
		 *
		 * @returns {void}
		 */
		processOauthError (params) {
			let message = 'We could not proces the Oauth response!'
			const error = get(params, 'error')

			if (get(params, 'error_description')) {
				message += ' ' + decodeURIComponent(get(params, 'error_description'))
				if (error) {
					message += ` [${decodeURIComponent(error)}]`
				}
			} else if (error) {
				message += ' ' + decodeURIComponent(error)
			}

			this.setActiveContentError(message)
		},
		/**
		 * Stop Listenign
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		stopListening () {
			window.clearInterval(this.oauthInterval)
			window.removeEventListener('message', this.listener)
		},
	},
}
